import { WORLD_DOMAIN } from '../../../constants.js';
import type { CharacterAppearance, CharacterNature } from '../../../domain/types.js';

export const PRIVACY_COPY =
  'First name plus optional last initial is a product data-minimization rule, not a legal guarantee.';

export const MAX_CHARACTERS = WORLD_DOMAIN.maxCharactersPerWorld;
export const SUGGESTED_CHARACTERS = WORLD_DOMAIN.suggestedCharactersPerWorld;
export const MAX_TRAITS = WORLD_DOMAIN.maxLearnedTraitsPerCharacter;
export const MAX_REASON = WORLD_DOMAIN.maxTraitReasonChars;

export function blankNature(): CharacterNature {
  const d = WORLD_DOMAIN.natureSliderDefault;
  return {
    sociability: d,
    agreeableness: d,
    emotionality: d,
    caution: d,
    discipline: d,
    dominance: d,
    empathy: d,
    curiosity: d,
    drive: d,
    sexual_drive: d,
    casual_sex_openness: d,
  };
}

export function defaultAppearance(): CharacterAppearance {
  return {
    skinColor: '#f1c27d',
    topStyle: 'shirt',
    topColor: '#4cc9f0',
    bottomStyle: 'trousers',
    bottomColor: '#3a506b',
    hairStyle: 'short',
    hairColor: '#3b2f2f',
  };
}
